import { render, staticRenderFns } from "./direct-deposit-agent-modal.vue?vue&type=template&id=52f13ae1&"
import script from "./direct-deposit-agent-modal.vue?vue&type=script&lang=js&"
export * from "./direct-deposit-agent-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports